/*
 * @Author: 3166396284@qq.com 3166396284@qq.com
 * @Date: 2022-07-09 07:24:24
 * @LastEditors: 3166396284@qq.com 3166396284@qq.com
 * @LastEditTime: 2025-03-11 13:06:20
 * @FilePath: \managerjpgj-web\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//import axios from 'axios'
import './styles/index.scss'
import moment from 'moment'
import axios from './http'

import { Loading, Message } from 'element-ui'
Vue.prototype.axios = axios
Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.use(require('vue-moment'));
Vue.prototype.moment = moment

Vue.filter('dateFormatYYYYMMDD', function(dateStr, pattern = 'YYYY-MM-DD') {
    return moment(dateStr).format(pattern);
})
Vue.filter('dateFormatYYYYMMDDHH', function(dateStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
        return moment(dateStr).format(pattern);
    })
    //dev
let apiurl = 'https://dev.jp-gj.cn'
    /*prd*/
    // let apiurl = 'http://115.28.210.163:8021'
    //localhost
    // let apiurl= "http://localhost:8021"
    // let apiurl = "http://jx17475331.51vip.biz/"
localStorage.setItem('aipUrl', apiurl)

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})

router.beforeEach((to, from, next) => {
    if (to.path === '/') {
        sessionStorage.removeItem('user');
    }
    var user = sessionStorage.getItem('user');
    if (!user && to.path !== '/') {
        next({
            path: '/'
        })
    } else {
        next();
    }
})


// WEBPACK FOOTER //
// ./src/main.js